import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ThemeProvider, makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import routes from '../routes';
import {
  backgroundColors,
  themePrimary,
  fontColors,
} from '../material-ui-theme';
import AppBar from '../components/AppBar';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100vw',
    height: '100vh',
    background: backgroundColors.grey,
    display: 'flex',
  },
  loading: {
    position: 'fixed',
    top: theme.spacing(7),
    left: '0',
    width: '100vw',
    display: 'flex',
    zIndex: '2000',
    [theme.breakpoints.up('sm')]: {
      top: theme.spacing(8),
    },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    paddingLeft: 12,
    paddingRight: 12,
    overflow: 'auto',
    paddingBottom: 120,

    [theme.breakpoints.up('md')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },

    '& .header': {
      '& header': {
        fontSize: '1.14rem',
        fontWeight: 500,
      },
      '& .actionBtn': {
        [theme.breakpoints.up('md')]: {
          textAlign: 'right',
        },
      },
    },

    '& .formHead': {
      margin: 0,
      textTransform: 'uppercase',
      fontWeight: 500,
      color: fontColors.grey,
      fontSize: '0.9rem',
    },
  },
  toolbar: theme.mixins.toolbar,
  article: {
    paddingTop: 0,
  },
  header: {
    fontSize: '1.2rem',
    fontWeight: 500,
  },
  actionBtn: {
    [theme.breakpoints.up('md')]: {
      textAlign: 'right',
    },
  },
  table: {
    '& thead th': {
      [theme.breakpoints.up('md')]: {
        fontWeight: 700,
        fontSize: '0.94rem',
      },
    },
    '& th': {
      [theme.breakpoints.up('md')]: {
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        fontWeight: 700,
        fontSize: '0.88rem',
        lineHeight: '1.7rem',
      },
    },
    '& td': {
      [theme.breakpoints.up('md')]: {
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        fontWeight: 500,
        fontSize: '0.88rem',
        lineHeight: '1.7rem',
      },
    },
  },
}));

function Master({ getRoutes, lodaingBarRequested }) {
  const classes = useStyles();

  return (
    <div className="master">
      <ThemeProvider theme={themePrimary}>
        <div className={classes.root}>
          <AppBar />
          <main className={classes.content}>
            <div className={classes.toolbar} />
            <article className={classes.article}>
              <React.Suspense fallback={<span />}>
                <Switch>{getRoutes(routes)}</Switch>
              </React.Suspense>
            </article>
          </main>
          {lodaingBarRequested ? (
            <LinearProgress className={classes.loading} />
          ) : null}
        </div>
      </ThemeProvider>
    </div>
  );
}

Master.defaultProps = {
  lodaingBarRequested: false,
};

Master.propTypes = {
  getRoutes: PropTypes.func.isRequired,
  lodaingBarRequested: PropTypes.bool,
};

class GeneralBase extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      lodaingBarRequested: false,
    };

    this.loadingStart = this.loadingStart.bind(this);
    this.loadingStop = this.loadingStop.bind(this);
  }
  getRoutes = () => {
    return routes.map((props) => (
      <Route
        key={props.id}
        path={props.path}
        render={(p) => (
          <props.component
            {...p}
            loadingStart={this.loadingStart}
            loadingStop={this.loadingStop}
          />
        )}
        exact={props.exact}
        strict={props.strict}
      />
    ));
  };

  loadingStart() {
    this.setState({ lodaingBarRequested: true });
  }

  loadingStop() {
    this.setState({ lodaingBarRequested: false });
  }

  render() {
    return (
      <Master
        getRoutes={this.getRoutes}
        authLogout={this.authLogout}
        lodaingBarRequested={this.state.lodaingBarRequested}
        {...this.props}
      />
    );
  }
}

GeneralBase.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default GeneralBase;
